import loadable from '@loadable/component';

export const Component = loadable(
  () => import('./containers/CancellationFormContainer')
);
export { default as propsFormatter } from './propsFormatter';
